/*
     Title: Constant for SEWING_INSPECTION
     Description: Constant for SEWING_INSPECTION
     Author: Iqbal Hossain
     Date: 29-January-2022
     Modified: 29-January-2022
*/

export const FETCH_SEWING_INSPECTION = 'FETCH_SEWING_INSPECTION';
export const FETCH_SEWING_INSPECTION_BY_QUERY = 'FETCH_SEWING_INSPECTION_BY_QUERY';
export const FETCH_SEWING_INSPECTION_BY_ID = 'FETCH_SEWING_INSPECTION_BY_ID';

/** Change Log
 * 29-Jan-2022(Iqbal): Add TOGGLE_SEWING_INSPECTION_SIDEBAR, FETCH_SEWING_INSPECTION_BY_QUERY, FETCH_SEWING_INSPECTION_BY_ID,
 */
